import { Tracking } from '@shared/tracking-timeline';

import api from '../config/api';

/** Fetch a project's Seguimiento by project code. */
export const getProjectTracking = (projectId: string) =>
  api.get<Tracking>(`/projects/${encodeURIComponent(projectId)}/tracking/`);
